import axios from "axios";
import CryptoJS from "crypto-js";

// export const domainName = "http://127.0.0.1:8000"
export const domainName = "https://dashboard.mayaplus.fr"
// export const domainName = "http://192.168.100.167:8000"


// export const link = "http://127.0.0.1:8000";
export const link = "https://api-services.mayaplus.fr";
// export const link = "http://192.168.100.167:8000";


const axiosClient = axios.create({
  // baseURL: "http://127.0.0.1:8000",
  baseURL: "https://api-services.mayaplus.fr",
  // baseURL: "http://192.168.100.167:8000",

});

// localUpload indicates either the video uploads are on local or S3
// true means we are stocking the videos on local , false means we are stocking then in S3

// export const localUpload = true
export const localUpload = false

const secretKeyEnv = process.env.REACT_APP_SECRET_KEY;

const getEncryptionKey = () => {
  const deviceInfo = navigator.userAgent; // Get device-specific info (like browser)
  const secretKey = secretKeyEnv;

  return secretKey + deviceInfo;
};

const decryptToken = (encryptedToken) => {
  try {
    const key = getEncryptionKey();
    const bytes = CryptoJS.AES.decrypt(encryptedToken, key);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    // console.error("Error decrypting token:", error);
    return null;
  }
};
export const percentageDifferenceRevenueBudget = 80

axiosClient.interceptors.request.use((config) => {
  const encryptedToken = localStorage.getItem("U_T");
  const token = encryptedToken ? decryptToken(encryptedToken) : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export default axiosClient;